import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, filter } from 'rxjs/operators';

import { User } from '../user.model';
import { UserService } from '../user.service';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { UserItemComponent } from '../user-item/user-item.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'fnsr-user-search',
  standalone: true,
  imports: [IconComponent, UserItemComponent, RouterModule],
  templateUrl: './user-search.component.html'
})
export class UserSearchComponent implements OnInit {
  keyUp$ = new Subject<string>();
  isLoading = false;
  foundUsers: User[] = [];

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.keyUp$.pipe(
      filter(term => term.length >= 2),
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      switchMap(query => this.userService.postFindUsersBySearch(query)),
      tap(() => this.isLoading = false)
    )
    .subscribe(users => this.foundUsers = users)
  }

}
